export enum QuestState {
  IDLE,
  PROCESS,
  DONE
}
